const SESSION_KEY = 'gx_tab_id';

/**
 * Returns a stable ID that uniquely identifies the current browser tab for
 * the lifetime of the page session. Stored in sessionStorage so it persists
 * across component mounts/unmounts but resets when the tab is closed.
 */
export const getTabId = (): string => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};
